import { InventoryControl } from "~/components/admin/dispatch";
import PageMeta from "~/components/common/meta";

export const ScreenInventoryControl: React.FC = () => {
  return (
    <>
      <PageMeta title="Inventory Control | Art Handler" />
      <InventoryControl />
    </>
  );
};
